module.exports = __webpack_public_path__ + "img/OurServiceAI_pic3.85f8c120.png";